module.exports = __webpack_public_path__ + "media/images/meta/stride/apple-touch-icon-f023bbaf31e9c83e61906049e7271942.png";